import CreateEmailButtonContainer from 'EmailComponents/emailCreation/CreateEmailButtonContainer';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import CreateEmailPanel from 'email-management-lib/EmailCreation/components/CreateEmailPanel/CreateEmailPanel';
import { FILTER, SEARCH } from 'email-management-lib/Shared/constants/manage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DashboardEmptyState({
  isSearchOrFilterOnTop,
  message,
  onClearEmailSearch,
  onClearAllEmailFilters
}) {
  const isCreateAnEmail = message.includes('createAnEmail');
  let imageName = isCreateAnEmail ? 'email-forwarding' : 'transactions';
  if (isSearchOrFilterOnTop) {
    imageName = 'empty-state-charts';
  }
  let element = {};
  if (isSearchOrFilterOnTop === SEARCH) {
    element = {
      ClearSearch({
        children
      }) {
        return /*#__PURE__*/_jsx(Button, {
          onClick: () => onClearEmailSearch === null || onClearEmailSearch === void 0 ? void 0 : onClearEmailSearch(),
          use: "link",
          children: children
        });
      }
    };
  } else if (isSearchOrFilterOnTop === FILTER) {
    element = {
      ClearFilter: function ClearFilter({
        children
      }) {
        return /*#__PURE__*/_jsx(Button, {
          onClick: () => onClearAllEmailFilters === null || onClearAllEmailFilters === void 0 ? void 0 : onClearAllEmailFilters(),
          use: "link",
          children: children
        });
      }
    };
  }
  return /*#__PURE__*/_jsx(EmptyState, {
    "data-test-id": "dashboard-empty-state-table",
    primaryContent: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${message}.title`
        })
      }), /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${message}.text`
        })
      }), isSearchOrFilterOnTop ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: element,
        message: `${message}.action_jsx`
      }) : /*#__PURE__*/_jsx(CreateEmailButtonContainer, {
        isDashboardEmptyState: true,
        use: "link",
        emailCreationComponent: CreateEmailPanel
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(View, {
      paddingInlineStart: "200",
      paddingBlockStart: "200",
      children: /*#__PURE__*/_jsx(Illustration, {
        height: "150px",
        name: imageName
      })
    }),
    secondaryContentWidth: 150
  });
}